<template>
  <div class="">
    <p class="text-center mb-8">——{{ $t("商品评价") }}——</p>
    <div v-if="data.length" class="px-3">
      <div
        class="space-y-2 rounded-2xl shadow-inner p-5"
        v-for="item in data"
        :key="item.id"
      >
        <div class="flex space-x-2">
          <img
            :src="$firstImage(item.images, 'small')"
            :onerror="defaultUrl"
            class="img h-7rem w-7rem"
          />

          <div>
            <p>{{ item.name }}</p>
            <p>{{ $p(item.price) }}</p>
          </div>
          <p></p>
        </div>
        <div v-if="item.comment" class="space-y-5 mb-8">
          <div class="flex space-x-4">
            <img
              :src="item.comment.user.icon"
              class="w-2.5rem h-2.5rem rounded-full"
            />
            <p>
              <span>{{ item.comment.user.name }}</span>
              <el-rate v-model="item.comment.score"></el-rate>
            </p>
          </div>
          <div class="pl-3.5rem">
            {{ item.comment.content }}
          </div>

          <div class="flex pl-3.5rem flex-wrap" v-if="item.comment.images">
            <div
              v-for="(i, index) in item.comment.images.split(';')"
              :key="index"
              class="pr-5 pt-2"
            >
              <img :src="i" class="w-7rem h-7rem img" :onerror="defaultUrl" />
            </div>
          </div>
        </div>
        <div v-else>{{ $t("此用户未评价") }}</div>
      </div>
      <div class="flex justify-center" v-if="total > 10">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          @current-change="handleCurrentChange"
          :page-size="6"
          :hide-on-single-page="true"
        >
        </el-pagination>
      </div>
    </div>
    <div v-else class="">
      <img src="@/assets/image/暂无数据.png" class="m-auto mt-50 mb-50" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: Array,
    total: Number,
  },
  setup(props, ctx) {
    const defaultUrl =
      'this.src="' + require("@/assets/image/透明logo.png") + '"';

    const handleCurrentChange = (val) => {
      ctx.emit("changePage", val);
    };
    return { handleCurrentChange, defaultUrl };
  },
};
</script>
<style lang="scss" scoped></style>
